/*
 * Hindi for the screens, keyed by the English text (see ./index.ts). The core: navigation, the shell, common buttons and
 * states, and the sales and billing screens. A text missing here shows in English.
 */
export const hi: Record<string, string> = {
  /* ---------- navigation: groups ---------- */
  Pipeline: "पाइपलाइन",
  Engage: "संपर्क",
  Revenue: "राजस्व",
  Purchases: "खरीद",
  "Sales documents": "बिक्री दस्तावेज़",
  Accounting: "लेखा",
  Admin: "प्रशासन",
  Modules: "मॉड्यूल",

  /* ---------- navigation: destinations ---------- */
  Dashboard: "डैशबोर्ड",
  "Pipeline, today and what needs you": "पाइपलाइन, आज का काम और जो आपकी प्रतीक्षा में है",
  Leads: "लीड",
  "Pipeline board and every lead": "पाइपलाइन बोर्ड और सभी लीड",
  Onboarding: "ऑनबोर्डिंग",
  "New clients: upfront payment, balance, invoices": "नए ग्राहक: अग्रिम भुगतान, शेष राशि, इनवॉइस",
  Meetings: "मीटिंग",
  "Calendar, synced with Google": "कैलेंडर, Google के साथ सिंक",
  Campaigns: "अभियान",
  "Email, WhatsApp and SMS": "ईमेल, WhatsApp और SMS",
  Announcements: "घोषणाएँ",
  "Updates from Wealthoak to clients": "Wealthoak की ओर से ग्राहकों को सूचनाएँ",
  CSI: "CSI",
  "Ratings from the 90-day email": "90-दिन वाले ईमेल से मिली रेटिंग",
  Partners: "पार्टनर",
  "Referral partners and applications": "रेफ़रल पार्टनर और आवेदन",
  Billing: "बिलिंग",
  "Invoices, payments and GST": "इनवॉइस, भुगतान और GST",
  Subscriptions: "सदस्यताएँ",
  "Plans, renewals and unpaid-invoice follow-up": "प्लान, नवीनीकरण और बकाया इनवॉइस पर फ़ॉलो-अप",
  "Billing rules": "बिलिंग नियम",
  "Retainers, sales receipts, late fees, revenue recognition": "रिटेनर, बिक्री रसीदें, विलंब शुल्क, राजस्व मान्यता",
  Customers: "ग्राहक",
  "Client master: tax details, terms, invoices": "ग्राहक मास्टर: कर विवरण, शर्तें, इनवॉइस",
  Items: "आइटम",
  "Catalog: plans and services, HSN/SAC": "कैटलॉग: प्लान और सेवाएँ, HSN/SAC",
  Inventory: "इन्वेंटरी",
  "Stock per location, adjustments, transfers, challans, packages": "स्थान-वार स्टॉक, समायोजन, स्थानांतरण, चालान, पैकेज",
  Projects: "प्रोजेक्ट",
  "Timesheets, timer, unbilled time and project profitability": "टाइमशीट, टाइमर, बिना बिल का समय और प्रोजेक्ट लाभप्रदता",
  Estimates: "अनुमान",
  "Quotes: send, accept, expire, convert": "कोटेशन: भेजें, स्वीकारें, समाप्त, बदलें",
  "Sales orders": "बिक्री आदेश",
  "Confirmed orders, convert to an invoice": "पुष्ट आदेश, इनवॉइस में बदलें",
  Invoices: "इनवॉइस",
  "Line items, GST per line, payments, proforma": "लाइन आइटम, प्रति लाइन GST, भुगतान, प्रोफ़ॉर्मा",
  "Recurring invoices": "आवर्ती इनवॉइस",
  "Invoices raised on a schedule": "तय समय पर बनने वाले इनवॉइस",
  "Credit notes": "क्रेडिट नोट",
  "With line items, or credit-only": "लाइन आइटम सहित, या केवल क्रेडिट",
  "Bills, purchase orders, payments made, vendor credits": "बिल, क्रय आदेश, किए गए भुगतान, विक्रेता क्रेडिट",
  "Bills, payments made, vendor credits": "बिल, किए गए भुगतान, विक्रेता क्रेडिट",
  Vendors: "विक्रेता",
  "Suppliers, GSTIN, terms and what we owe": "आपूर्तिकर्ता, GSTIN, शर्तें और हमारी देनदारी",
  Expenses: "खर्च",
  "Spend by category, with input GST": "श्रेणी-वार खर्च, इनपुट GST सहित",
  "Vendor portal": "विक्रेता पोर्टल",
  "Vendor links, uploaded invoices, contact and bank changes": "विक्रेता लिंक, अपलोड किए गए इनवॉइस, संपर्क और बैंक बदलाव",
  "Chart of accounts, journals, banking and reports": "खातों का चार्ट, जर्नल, बैंकिंग और रिपोर्ट",
  Compliance: "अनुपालन",
  "TDS, e-invoices, e-way bills and GST returns": "TDS, ई-इनवॉइस, ई-वे बिल और GST रिटर्न",
  "TDS, e-invoices and GST returns": "TDS, ई-इनवॉइस और GST रिटर्न",
  "TDS and GST returns": "TDS और GST रिटर्न",
  Reports: "रिपोर्ट",
  "Sales, receivables, purchases, taxes and subscription metrics": "बिक्री, प्राप्य, खरीद, कर और सदस्यता आँकड़े",
  Customization: "अनुकूलन",
  "Custom fields, tags, numbering, templates, automation, webhooks": "कस्टम फ़ील्ड, टैग, क्रमांकन, टेम्पलेट, ऑटोमेशन, वेबहुक",
  Settings: "सेटिंग्स",
  "Users, roles, approvals, audit log, vendor portal, messaging, custom modules": "उपयोगकर्ता, भूमिकाएँ, अनुमोदन, ऑडिट लॉग, विक्रेता पोर्टल, संदेश, कस्टम मॉड्यूल",
  "Users, roles, approvals, audit log, messaging": "उपयोगकर्ता, भूमिकाएँ, अनुमोदन, ऑडिट लॉग, संदेश",
  "Custom modules": "कस्टम मॉड्यूल",
  "Record types your team defined": "आपकी टीम द्वारा बनाए गए रिकॉर्ड प्रकार",
  "Custom module": "कस्टम मॉड्यूल",

  /* ---------- shell ---------- */
  More: "और",
  "All destinations": "सभी स्क्रीन",
  close: "बंद करें",
  "Skip to content": "सामग्री पर जाएँ",
  "Account menu": "खाता मेनू",
  "Role: {role}": "भूमिका: {role}",
  "Sign out": "साइन आउट",
  "Your role ({role}) can't open {screen}. Ask an Admin if you need it.": "आपकी भूमिका ({role}) {screen} नहीं खोल सकती। ज़रूरत हो तो किसी एडमिन से कहें।",
  "WealthOak CRM, go to Dashboard": "WealthOak CRM, डैशबोर्ड पर जाएँ",
  Language: "भाषा",
  "Language and formats": "भाषा और प्रारूप",
  "Number format": "संख्या प्रारूप",
  "Date format": "तिथि प्रारूप",
  "Organisation default": "संगठन का डिफ़ॉल्ट",
  "Saved.": "सहेजा गया।",
  "Documents and emails": "दस्तावेज़ और ईमेल",
  "Invoices, estimates, credit notes and their emails go to this customer in this language.": "इनवॉइस, अनुमान, क्रेडिट नोट और उनके ईमेल इस ग्राहक को इसी भाषा में जाते हैं।",
  "Language & formats": "भाषा और प्रारूप",
  "Default document language": "दस्तावेज़ों की डिफ़ॉल्ट भाषा",
  "Lakh and crore group digits in twos after the first thousand.": "लाख और करोड़ में पहले हज़ार के बाद अंक दो-दो के समूह में लिखे जाते हैं।",
  "Documents and emails go out in each customer's language (set on the customer), else in the default below. Numbers and dates on documents use these formats. Each person picks their own screen language and formats from the account menu.":
    "दस्तावेज़ और ईमेल हर ग्राहक की अपनी भाषा में (ग्राहक पर सेट), अन्यथा नीचे दी गई डिफ़ॉल्ट भाषा में जाते हैं। दस्तावेज़ों पर संख्याएँ और तिथियाँ इन प्रारूपों में होती हैं। हर व्यक्ति खाता मेनू से अपनी स्क्रीन की भाषा और प्रारूप चुनता है।",
  "12,34,567.89 (lakh, crore)": "12,34,567.89 (लाख, करोड़)",
  Layout: "लेआउट",
  Paper: "काग़ज़",
  Templates: "टेम्पलेट",

  /* ---------- common ---------- */
  "Loading…": "लोड हो रहा है…",
  "Try again": "फिर कोशिश करें",
  Close: "बंद करें",
  Save: "सहेजें",
  "Save changes": "बदलाव सहेजें",
  "Saving…": "सहेजा जा रहा है…",
  Cancel: "रद्द करें",
  Delete: "हटाएँ",
  Edit: "संपादित करें",
  New: "नया",
  Back: "वापस",
  Search: "खोजें",
  Export: "निर्यात",
  Print: "प्रिंट",
  "Print view": "प्रिंट दृश्य",
  "Download PDF": "PDF डाउनलोड करें",
  Email: "ईमेल",
  "Email to client": "ग्राहक को ईमेल करें",
  "Email again": "फिर से ईमेल करें",
  "Send again": "फिर से भेजें",
  Record: "दर्ज करें",
  Issue: "जारी करें",
  Apply: "लागू करें",
  Confirm: "पुष्टि करें",
  Yes: "हाँ",
  No: "नहीं",
  All: "सभी",
  None: "कोई नहीं",
  "None yet.": "अभी कोई नहीं।",
  Optional: "वैकल्पिक",
  Default: "डिफ़ॉल्ट",
  Active: "सक्रिय",
  Show: "दिखाएँ",
  Status: "स्थिति",
  Date: "दिनांक",
  Customer: "ग्राहक",
  Client: "ग्राहक",
  Amount: "राशि",
  "Amount (₹)": "राशि (₹)",
  Total: "कुल",
  Balance: "शेष",
  "Balance due": "शेष देय राशि",
  Due: "देय",
  "Due date": "देय तिथि",
  Reference: "संदर्भ",
  Note: "टिप्पणी",
  Notes: "टिप्पणियाँ",
  Reason: "कारण",
  "Reason (optional)": "कारण (वैकल्पिक)",
  Method: "तरीका",
  Location: "स्थान",
  Currency: "मुद्रा",
  Kind: "प्रकार",
  Subject: "विषय",
  Item: "मद",
  "Item or service": "आइटम या सेवा",
  "Description (optional)": "विवरण (वैकल्पिक)",
  Quantity: "मात्रा",
  Qty: "मात्रा",
  Unit: "इकाई",
  Rate: "दर",
  Discount: "छूट",
  "GST %": "GST %",
  GST: "GST",
  "HSN/SAC": "HSN/SAC",
  "Taxable value": "कर योग्य मूल्य",
  "Sub total": "उप-योग",
  "Shipping charge": "शिपिंग शुल्क",
  Adjustment: "समायोजन",
  "Adjustment label": "समायोजन का नाम",
  "Round off": "पूर्णांकन",
  Amounts: "राशियाँ",
  Money: "राशि",
  History: "इतिहास",
  Overview: "सारांश",
  Payments: "भुगतान",
  Link: "लिंक",
  Never: "कभी नहीं",

  /* ---------- statuses ---------- */
  Draft: "ड्राफ़्ट",
  Drafts: "ड्राफ़्ट",
  Open: "खुला",
  Sent: "भेजा गया",
  Issued: "जारी",
  Paid: "भुगतान हो गया",
  "Partially paid": "आंशिक भुगतान",
  Overdue: "बकाया",
  Void: "रद्द",
  Voided: "रद्द किया गया",
  Accepted: "स्वीकृत",
  Declined: "अस्वीकृत",
  Expired: "समाप्त",
  Converted: "परिवर्तित",
  Invoiced: "इनवॉइस बना",
  Credited: "क्रेडिट किया गया",
  Closed: "बंद",
  Refunded: "धनवापसी की गई",
  Emailed: "ईमेल किया गया",
  Paused: "रुका हुआ",
  Stopped: "बंद किया गया",
  Finished: "पूरा हुआ",
  "Not yet": "अभी नहीं",
  "Not yet sent": "अभी नहीं भेजा गया",
  "Not yet issued": "अभी जारी नहीं",
  "Waiting for an answer": "उत्तर की प्रतीक्षा",
  Outstanding: "बकाया राशि",

  /* ---------- sales documents ---------- */
  Estimate: "अनुमान",
  "Sales order": "बिक्री आदेश",
  Invoice: "इनवॉइस",
  "Sales invoice": "बिक्री इनवॉइस",
  "Proforma invoice": "प्रोफ़ॉर्मा इनवॉइस",
  "Proforma invoices": "प्रोफ़ॉर्मा इनवॉइस",
  "Recurring invoice": "आवर्ती इनवॉइस",
  Recurring: "आवर्ती",
  "Credit note": "क्रेडिट नोट",
  "Onboarding invoice": "ऑनबोर्डिंग इनवॉइस",
  "Estimate date": "अनुमान दिनांक",
  "Invoice date": "इनवॉइस दिनांक",
  "Order date": "आदेश दिनांक",
  "Valid until": "मान्य तिथि",
  "Place of supply": "आपूर्ति का स्थान",
  "Our GSTIN": "हमारा GSTIN",
  "Customer GSTIN": "ग्राहक GSTIN",
  "Client GSTIN": "ग्राहक GSTIN",
  "Billed to": "बिल प्राप्तकर्ता",
  "Legal name": "कानूनी नाम",
  "Registered state": "पंजीकृत राज्य",
  State: "राज्य",
  Supply: "आपूर्ति",
  "What is being sold": "क्या बेचा जा रहा है",
  "Reference / PO number": "संदर्भ / PO संख्या",
  "Notes (shown on the document)": "टिप्पणियाँ (दस्तावेज़ पर दिखेंगी)",
  "Terms and conditions": "नियम एवं शर्तें",
  "Document discount": "दस्तावेज़ पर छूट",
  "Document discount type": "दस्तावेज़ छूट का प्रकार",
  "Discount on the whole document": "पूरे दस्तावेज़ पर छूट",
  "Shipping GST %": "शिपिंग GST %",
  "Shipping SAC": "शिपिंग SAC",
  "Due after (days)": "कितने दिन बाद देय",
  "Save as draft": "ड्राफ़्ट के रूप में सहेजें",
  "Save and send": "सहेजें और भेजें",
  "Save and issue": "सहेजें और जारी करें",
  "Save and confirm": "सहेजें और पुष्टि करें",
  "Issue this invoice?": "यह इनवॉइस जारी करें?",
  "Delete this draft?": "यह ड्राफ़्ट हटाएँ?",
  "A draft has no number yet, so nothing is lost but its lines.": "ड्राफ़्ट की अभी कोई संख्या नहीं है, इसलिए केवल उसकी लाइनें हटेंगी।",
  "Mark declined": "अस्वीकृत चिह्नित करें",
  "Declined because": "अस्वीकृति का कारण",
  "Converted to": "इसमें बदला गया",
  "Made from": "इससे बना",
  "Record payment": "भुगतान दर्ज करें",
  "How was it paid": "भुगतान कैसे हुआ",
  "Received on": "प्राप्ति की तिथि",
  Received: "प्राप्त",
  "Reference (UTR, cheque no.)": "संदर्भ (UTR, चेक संख्या)",
  "Reference (UTR)": "संदर्भ (UTR)",
  "Void invoice": "इनवॉइस रद्द करें",
  "Voided because": "रद्द करने का कारण",
  "Issue credit note": "क्रेडिट नोट जारी करें",
  "New credit note": "नया क्रेडिट नोट",
  "Apply credit": "क्रेडिट लागू करें",
  "Credit applied": "लागू क्रेडिट",
  "Credit total": "कुल क्रेडिट",
  "Credit only": "केवल क्रेडिट",
  "Unused credit": "अप्रयुक्त क्रेडिट",
  "Unused credit by client": "ग्राहक-वार अप्रयुक्त क्रेडिट",
  "Applied to invoices": "इनवॉइस पर लागू",
  "Items credited": "क्रेडिट किए गए आइटम",
  "Credits, refunds and void": "क्रेडिट, धनवापसी और रद्दीकरण",
  "Adjust this invoice": "यह इनवॉइस समायोजित करें",
  Against: "के विरुद्ध",
  "Amount to credit (₹, GST included)": "क्रेडिट राशि (₹, GST सहित)",
  "Open invoice of the same client": "उसी ग्राहक का खुला इनवॉइस",
  "Credit note number or customer": "क्रेडिट नोट संख्या या ग्राहक",
  "Credit note number or client": "क्रेडिट नोट संख्या या ग्राहक",
  "Invoice number or client": "इनवॉइस संख्या या ग्राहक",
  "Search invoices": "इनवॉइस खोजें",
  "Search credit notes": "क्रेडिट नोट खोजें",
  "Record refund": "धनवापसी दर्ज करें",
  Refund: "धनवापसी",
  "Refunded on": "धनवापसी की तिथि",
  "Date refunded": "धनवापसी की तिथि",
  "Amount refunded (₹)": "लौटाई गई राशि (₹)",
  "How was it refunded": "धनवापसी कैसे हुई",
  "How was it paid back?": "राशि कैसे लौटाई गई?",
  "Payment link": "भुगतान लिंक",
  "Make a payment link": "भुगतान लिंक बनाएँ",
  "Make a new link": "नया लिंक बनाएँ",
  "Paid through the link": "लिंक से भुगतान हुआ",
  "Replaced by a newer link": "नए लिंक से बदला गया",
  "TDS withheld by the customer": "ग्राहक द्वारा काटा गया TDS",
  "TDS withheld by the customer (₹)": "ग्राहक द्वारा काटा गया TDS (₹)",
  "Tax withheld (₹)": "काटा गया कर (₹)",
  "TDS section": "TDS धारा",
  Section: "धारा",
  "Customer's TAN": "ग्राहक का TAN",
  "Certificate number": "प्रमाणपत्र संख्या",
  "Internal note (optional)": "आंतरिक टिप्पणी (वैकल्पिक)",
  "Issued by": "जारीकर्ता",
  "Issued and emailed": "जारी और ईमेल किया गया",
  "Issued and emailed to the customer": "जारी करके ग्राहक को ईमेल किया गया",
  "Issued and emailed straight away": "तुरंत जारी और ईमेल",
  "Left as a draft for me to check": "मेरी जाँच के लिए ड्राफ़्ट रहे",
  "Left as a draft for you to check and issue": "आपकी जाँच और जारी करने के लिए ड्राफ़्ट",
  "Drafted for checking": "जाँच के लिए ड्राफ़्ट बना",
  "Default location": "डिफ़ॉल्ट स्थान",

  /* ---------- recurring ---------- */
  "New recurring invoice": "नया आवर्ती इनवॉइस",
  "Schedule name": "शेड्यूल का नाम",
  Schedule: "शेड्यूल",
  "Repeat every": "हर इतने समय पर दोहराएँ",
  Repeats: "दोहराव",
  "First invoice on": "पहला इनवॉइस",
  "Ends on (optional)": "समाप्ति तिथि (वैकल्पिक)",
  "Or after this many invoices (optional)": "या इतने इनवॉइस के बाद (वैकल्पिक)",
  "Each invoice is": "हर इनवॉइस",
  "Each invoice": "हर इनवॉइस",
  "Next invoice": "अगला इनवॉइस",
  "Next to run": "अगली बार",
  "Last ran": "पिछली बार",
  "Invoices raised": "बने इनवॉइस",
  "Raised so far": "अब तक बने",
  Raised: "बनाया गया",
  Starts: "आरंभ",
  Ends: "समाप्ति",
  "Start schedule": "शेड्यूल शुरू करें",
  Made: "बनाया गया",

  /* ---------- billing ---------- */
  "Invoices issued after GST was set up": "GST सेट होने के बाद जारी इनवॉइस",
  "GST on invoices": "इनवॉइस पर GST",
  "GST by HSN/SAC": "HSN/SAC-वार GST",
  "GST in collected": "वसूला गया GST",
  "GST rate (%)": "GST दर (%)",
  "SAC code (optional)": "SAC कोड (वैकल्पिक)",
  "Save GST settings": "GST सेटिंग्स सहेजें",
  "Invoiced this FY": "इस वित्त वर्ष में इनवॉइस",
  "Collected this FY": "इस वित्त वर्ष में वसूली",
  "Refunded this FY": "इस वित्त वर्ष में धनवापसी",
  "Credit notes issued": "जारी क्रेडिट नोट",
  Used: "प्रयुक्त",
  "Invoices and payments come from Onboarding. GST settings are set under the GST tab.": "इनवॉइस और भुगतान ऑनबोर्डिंग से आते हैं। GST सेटिंग्स GST टैब में हैं।",
  "An invoice with line items. Payments, credit notes, void, print and PDF are on the invoice in Sales.": "लाइन आइटम वाला इनवॉइस। भुगतान, क्रेडिट नोट, रद्दीकरण, प्रिंट और PDF बिक्री में इनवॉइस पर हैं।",
  "Open in Sales → Invoices": "बिक्री → इनवॉइस में खोलें",
  "The invoice for": "इसका इनवॉइस:",
  "has no payment on it. Voiding it stops its payment link and reminders. This can't be undone.": "पर कोई भुगतान नहीं है। रद्द करने से इसका भुगतान लिंक और अनुस्मारक बंद हो जाएँगे। इसे पलटा नहीं जा सकता।",
  "Voiding…": "रद्द किया जा रहा है…",
  "Why is this being credited?": "यह क्रेडिट क्यों दिया जा रहा है?",
  "Email the credit note to the client": "क्रेडिट नोट ग्राहक को ईमेल करें",
  "Apply to an invoice": "किसी इनवॉइस पर लागू करें",
  "No open invoice for this client to apply it to. Open the invoice it is against to refund it.": "इस ग्राहक का कोई खुला इनवॉइस नहीं है जिस पर इसे लागू किया जा सके। धनवापसी के लिए संबंधित इनवॉइस खोलें।",
  "No open invoice for this client to apply it to. Refund it instead.": "इस ग्राहक का कोई खुला इनवॉइस नहीं है जिस पर इसे लागू किया जा सके। इसके बजाय धनवापसी करें।",
  "Applying…": "लागू किया जा रहा है…",
  "Choose…": "चुनें…",
  none: "कोई नहीं",

  /* ---------- sales screens: actions and hints ---------- */
  "Email it to the customer": "इसे ग्राहक को ईमेल करें",
  "Email to customer": "ग्राहक को ईमेल करें",
  "Email the link": "लिंक ईमेल करें",
  "Issuing…": "जारी किया जा रहा है…",
  "Issue invoice": "इनवॉइस जारी करें",
  "Confirm order": "आदेश की पुष्टि करें",
  "Mark accepted": "स्वीकृत चिह्नित करें",
  "Record TDS withheld": "काटा गया TDS दर्ज करें",
  "Convert to sales order": "बिक्री आदेश में बदलें",
  "Convert to invoice": "इनवॉइस में बदलें",
  "Delete draft": "ड्राफ़्ट हटाएँ",
  "Keep it": "रहने दें",
  "Opening…": "खोला जा रहा है…",
  "Making…": "बनाया जा रहा है…",
  "Add a line": "लाइन जोड़ें",
  "Choose a customer…": "ग्राहक चुनें…",
  "Type the item below, or choose one…": "नीचे आइटम लिखें, या कोई चुनें…",
  "Number, customer or reference": "संख्या, ग्राहक या संदर्भ",
  "Void / credited": "रद्द / क्रेडिट किए गए",
  "Declined / expired": "अस्वीकृत / समाप्त",
  "Sub total (incl. GST)": "उप-योग (GST सहित)",
  "Rates and amounts include GST. The totals below are the server's.": "दरों और राशियों में GST शामिल है। नीचे के योग सर्वर द्वारा गणना किए गए हैं।",
  "Quotes for customers: send, accept or decline, expiry, and convert to a sales order or an invoice.": "ग्राहकों के लिए कोटेशन: भेजें, स्वीकार या अस्वीकार करें, समाप्ति, और बिक्री आदेश या इनवॉइस में बदलें।",
  "Confirmed orders from customers. Convert one to an invoice when it is time to bill.": "ग्राहकों के पुष्ट आदेश। बिल बनाने का समय आने पर इसे इनवॉइस में बदलें।",
  "Invoices with line items and GST per line, and proforma invoices. Issued invoices also appear in Billing.": "लाइन आइटम और प्रति लाइन GST वाले इनवॉइस, और प्रोफ़ॉर्मा इनवॉइस। जारी इनवॉइस बिलिंग में भी दिखते हैं।",
  "Reductions of an invoice, with line items, or credit for a customer with no invoice. GST is reversed line by line.": "किसी इनवॉइस में कमी, लाइन आइटम सहित, या बिना इनवॉइस वाले ग्राहक के लिए क्रेडिट। GST हर लाइन पर उलटा जाता है।",
  "Invoices raised on a schedule, as drafts to check or issued and emailed by themselves.": "तय समय पर बनने वाले इनवॉइस, जाँच के लिए ड्राफ़्ट के रूप में या अपने आप जारी और ईमेल होकर।",
  "Rates include GST. Change the lines later and only the invoices raised after that change.": "दरों में GST शामिल है। लाइनें बाद में बदलने पर केवल उसके बाद बनने वाले इनवॉइस बदलेंगे।",
  "New schedule": "नया शेड्यूल",
  "New {kind}": "नया {kind}",
  "Edit {label}": "{label} संपादित करें",
  "Send {kind}": "{kind} भेजें",
  "{n} open invoices": "{n} खुले इनवॉइस",
  "{n} past due date": "{n} देय तिथि पार",
  Pause: "रोकें",
  Resume: "फिर शुरू करें",
  Stop: "बंद करें",
  days: "दिन",
  weeks: "सप्ताह",
  months: "महीने",
  years: "वर्ष",
  UPI: "UPI",
  NEFT: "NEFT",
  "In-app": "ऐप में",
  WhatsApp: "WhatsApp",
  SMS: "SMS",
  Cr: "करोड़",
  L: "लाख",
  today: "आज",
  tomorrow: "कल",
  yesterday: "बीता कल",
  "in {n} days": "{n} दिन में",
  "{n} days ago": "{n} दिन पहले",
  /* ---------- ui/workspaces/ClientsWorkspace.tsx: Clients and Legal ---------- */
  "Every client and their legal agreement": "हर क्लाइंट और उसका कानूनी एग्रीमेंट",
};
